<template lang="html">

  <section class="banner-tienda column-center animation" id="banner-tienda" :style="`background:url('/static/img/productos/background-tienda.png') center/cover no-repeat`">
    <div class="container -xxs textos">
      <a class="enlace-cover" target="_blank" href="https://tienda.aldonzagourmet.com/"></a>
      <h2 class="title">Visita nuestra tienda online</h2>
      <a class="btn" target="_blank" href="https://tienda.aldonzagourmet.com/">
        <span>IR A LA TIENDA</span>
      </a>
    </div>
  </section>

</template>

<script lang="js">
  export default {
    name: 'banner-tienda'
  }
</script>

<style scoped lang="scss">
  .banner-tienda {
    padding: 100px 0;
    height: 100%;
    position: relative;
    overflow: hidden;

    .container {
      max-width: 768px;
    }

    .title {
      margin-bottom: 30px;
      text-align: center;
      line-height: 40px;
      transform: translateY(500px);
      opacity: 0;
      transition: 1s;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 30%;
        height: 1px;
        background: #fff;
        display: inline-block;
        margin: 0 auto;
        text-align: center;
        right: 0;
      }
    }

    .btn {
      position: relative;
      z-index: 6;
      transform: translateY(500px);
      opacity: 0;
      transition: 1s;
      transition-delay: .5s;
    }

    &.launched {

      .title,
      .btn {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  @media screen and (max-width: 700px) {
    .banner-tienda .title {
      line-height: 25px;
    }

    .banner-tienda {
      height: auto;
      padding: 40px 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/productos/banner-tienda.vue